var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 77,
    viewBox: "0 0 53 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 77,
    rx: 8,
    fill: "#F4F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M26.5003 38.5002C29.3768 38.5002 31.7087 36.1683 31.7087 33.2918C31.7087 30.4153 29.3768 28.0835 26.5003 28.0835C23.6238 28.0835 21.292 30.4153 21.292 33.2918C21.292 36.1683 23.6238 38.5002 26.5003 38.5002Z",
    fill: "#8F9BBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 41.104C21.2812 41.104 17.0312 44.604 17.0312 48.9165C17.0312 49.2082 17.2604 49.4373 17.5521 49.4373H35.4479C35.7396 49.4373 35.9687 49.2082 35.9687 48.9165C35.9687 44.604 31.7187 41.104 26.5 41.104Z",
    fill: "#8F9BBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDefault);
export default __webpack_public_path__ + "static/media/patientDefault.798924c040c7cf23df2c067da83d8e64.svg";
export { ForwardRef as ReactComponent };